import ApiService from './api.service'
const MahallaEmployeeService = {
  GetList(data) {
    return ApiService.post(`/MahallaEmployee/GetList`, data);
  },
  Get(id) {
    if (id == 0 || id == undefined || id == null || id == "") {
      return ApiService.get(`/MahallaEmployee/Get`);
    }
    return ApiService.get(`/MahallaEmployee/Get/${id}`);
  },
  GetPhoto(photoId) {
    return ApiService.print(`/MahallaEmployee/GetPhoto?photoId=${photoId}`);
  },
  SyncMfyEmployees(mfyId) {
    return ApiService.post(`/MahallaEmployee/SyncMfyEmployees/${mfyId}`);
  },
};
export default MahallaEmployeeService